import * as styles from "./DataTableSelectCell.css";

import type { JSX, MouseEvent } from "react";

import { Checkbox } from "@frontend/components/atoms/Checkbox";

import type {
  DataTableSize,
  DataTableSpacing,
  DataTableVariant,
} from "./DataTable.types";
import { dataTableSpacingValue } from "./cellSizeStyles";

type DataTableSelectCellProps = {
  label?: string;
  checked?: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  onCheckedChange?: (checked: boolean, shiftKey: boolean) => void;
  size: DataTableSize;
  variant: DataTableVariant;
  horizontalSpacing: DataTableSpacing;
  header?: boolean;
  sticky?: boolean;
  opaque?: boolean;
};

function stopPropagation(event: MouseEvent) {
  event.stopPropagation();
}

export function DataTableSelectCell({
  label,
  checked = false,
  indeterminate = false,
  disabled = false,
  onCheckedChange,
  size,
  variant,
  horizontalSpacing,
  header = false,
  sticky = false,
  opaque = false,
}: DataTableSelectCellProps): JSX.Element {
  return (
    <div
      role={header ? "columnheader" : "cell"}
      className={styles.cell({ variant, header, sticky, opaque })}
      style={{ paddingInlineStart: dataTableSpacingValue[horizontalSpacing] }}
      data-slot="data-table-select-cell"
      onClick={stopPropagation}
    >
      {onCheckedChange ? (
        <Checkbox
          size={size}
          aria-label={label}
          checked={checked}
          indeterminate={indeterminate}
          disabled={disabled}
          onCheckedChange={(next, details) =>
            onCheckedChange(
              next,
              Boolean((details.event as { shiftKey?: boolean }).shiftKey),
            )
          }
        />
      ) : null}
    </div>
  );
}
